// @import_dependencies
import { store } from 'app_storage/redux-storage'
import { ParamsListMessageForum, ParamsSendMessageForum, IParamsGetBetterForumMessage } from 'app_types/admin/forum/forumMessageTypes'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
// @end

class ForumMessageService{

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  /**
   * @INFO Crear un mensaje en un foro
   * @param params
   * @returns
   */
  async sendMessage(params: ParamsSendMessageForum) {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/events/forum/${params.forum}/send-message`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  /**
   * @INFO Listar los mensajes de un foro
   * @param params
   * @returns
   */
  async list(params: ParamsListMessageForum) {
    this.refreshAuthToken()

    if (!params.user) {
      delete params.user
    }

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/events/forum/${params.forum}/`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  /**
   * @INFO Obtener el mensaje con mas likes
   * @param params
   * @returns
   */
  async getBetterMessage(params: IParamsGetBetterForumMessage) {
    this.refreshAuthToken()

    if (!params.user) {
      delete params.user
    }

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/events/forum/${params.forum}/better-message`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }
}

export default ForumMessageService;
